import React, { Component } from 'react';

class PasswordChecklist extends Component {
  constructor(props) {
    super(props)

    this.state = {
      password: props.password || ''
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.password !== this.props.password) {
      this.setState({ password: this.props.password });
    }
  }

  requirementLength() {
    let requirement = /^(?=.{8,})/

    return requirement.test(this.state.password);
  }

  requirementUppercase() {
    let requirement = /^(?=.*[A-Z])/

    return requirement.test(this.state.password);
  }

  requirementNumber() {
    let requirement = /^(?=.*[0-9])/

    return requirement.test(this.state.password);
  }

  requirementSpecialCharacter() {
    let requirement = /^(?=.*[!@#\$%\^&\*])/

    return requirement.test(this.state.password);
  }

  render() {
    return (
      <p>
        Your password must be <span className={`font-weight-bold ${this.requirementLength() ? 'text-success' : ''}`}>8 Characters</span> long,
        include an <span className={`font-weight-bold ${this.requirementUppercase() ? 'text-success' : ''}`}>Uppercase Letter</span> (A-Z),
        include a <span className={`font-weight-bold ${this.requirementNumber() ? 'text-success' : ''}`}>Number</span> (0-9),
        and a <span className={`font-weight-bold ${this.requirementSpecialCharacter() ? 'text-success' : ''}`}>Special Character</span>: !, @, #, $, %, ^, &, *
      </p>
    )
  }
}

export default PasswordChecklist